import { useQuery, useQueryClient } from "@tanstack/react-query"
import {
  GetDetalleAmortizacionActivoById,
  getActivoAmortizaciones,
  getActivoById,
} from "./Activo.service"

export function useActivoById(id?: string) {
  const queryClient = useQueryClient()
  const {
    data: activoByIdData,
    error: activoByIdError,
    isLoading: activoByIdIsLoading,
    refetch: activoByIdRefetch,
  } = useQuery({
    queryKey: ["activo", id],
    enabled: Boolean(id),
    queryFn: () => getActivoById(id ?? ""),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })

  const activoByIdInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["activo"] })

  return {
    activoByIdData,
    activoByIdError,
    activoByIdIsLoading,
    activoByIdRefetch,
    activoByIdInvalidation,
  }
}

export const useGetDetalleAmortizacionActivoById = (id?: string) => {
  const queryClient = useQueryClient()
  const {
    data: detalleAmortizacionActivo,
    error: detalleAmortizacionActivoError,
    isLoading: detalleAmortizacionActivoIsLoading,
    refetch: detalleAmortizacionActivoRefetch,
  } = useQuery({
    queryKey: ["detalleAmortizacionActivo", id],
    enabled: Boolean(id),
    queryFn: () => GetDetalleAmortizacionActivoById(id ?? ""),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })

  const detalleAmortizacionActivoInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["detalleAmortizacionActivo"] })

  return {
    detalleAmortizacionActivo,
    detalleAmortizacionActivoError,
    detalleAmortizacionActivoIsLoading,
    detalleAmortizacionActivoRefetch,
    detalleAmortizacionActivoInvalidation,
  }
}

export const useGetActivoAmortizaciones = (id: string) => {
  const queryClient = useQueryClient()
  const {
    data: activoAmortizaciones,
    error: activoAmortizacionesError,
    isLoading: activoAmortizacionesIsLoading,
    refetch: activoAmortizacionesRefetch,
  } = useQuery({
    queryKey: ["activoAmortizaciones", id],
    enabled: Boolean(id),
    queryFn: () => getActivoAmortizaciones(id),
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })

  const activoAmortizacionesInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["activoAmortizaciones"] })

  return {
    activoAmortizaciones,
    activoAmortizacionesError,
    activoAmortizacionesIsLoading,
    activoAmortizacionesRefetch,
    activoAmortizacionesInvalidation,
  }
}
